import React, { Component } from "react";
import { Link } from "react-router-dom";
class Carees_SiteContent extends Component {
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">ZAŠTO ODABRATI STARTUP?</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p
              className="sub-heading font-size-16 line-height-28 text-666 margin-top-27 letter-spacing-01"
              style={{ textAlign: "justify" }}
            >
              Za startupe ste sigurno čuli. Termin koji se sve više koristi i
              mnogi ga olako povežu s tvrtkama koje su u svojim prvim fazama. Da
              li je to baš tako? Nije. Ključna razlika je ta što startupi
              razvijaju proizvod ili uslugu s kojom na određeni način mijenjaju
              tržište. Cilj je pronaći izazove koji sadrže repetitivne tj.
              ponavljajuće modele, a koji su istovremeno skalabilni u
              zadržavanju inicijalnih rješenja i funkcija. Ukoliko se
              istovremeno radi o znatnom tržištu tj. rješavanju problema većem
              broju ljudi ili kompanija, onda tvrtku možemo okarakterizirati kao
              startup. Iz naše pozicije gledanja govorimo i o visokotehnološkim
              rješenjima te novim tehnologijama.
              <br />
              Sama organizacija startup tvrtke se bazira na potencijalu brzog
              širenja, agilnim metodama rada, skalabilnom ekonomskom modelu te
              brzoj prilagodbi u novim okolnostima. Isto tako tu je iznimna
              nesigurnost u početku poslovanja po svim aspektima. Od same
              pretpostavke da idejno rješenje ima smisla, preko realizacije,
              okupljanja tima i motiviranja u teškim trenutcima (uglavnom su
              takvi trenutci na početku) pa sve do akvizicije samih korisnika. S
              druge je, pak, strane dinamika događanja stvorena za ljude koji se
              ne uklapaju u poslovne modele u kojima iz dana u dan dolaze na
              posao i rade identičan posao, onima kojima je uzbuđenje tjedna
              trenutak kada "kopirka sažvače papir". Stalno razmišljanje i
              davanje idjenih prijedloga, kroz prizmu budućeg milijunskog broja
              korisnika mnogima stvara istinski užitak rada. Ne postoji
              management koji donosi odluke, ne postoje teme koje se ne smiju
              otvoriti… Ovo je trenutak kada se donosi odluka - Da. Ovaj način
              rada je za mene.
              <br />
              <br />
              Tipične faze startupa su:
              <br />
              1. <b>Ideja</b> pa sve do faze koncepta koji bi mogao teoretski
              funkcionirati. Faza koja uglavnom traje oko tri do četiri mjeseca.
              Za CityX je potrajala oko šest do sedam mjeseci jer se istovremeno
              radio development nekih idejnih rješenja. Oko 20% startupova ne
              preživi ovu fazu.
              <br />
              2. <b>Development</b>, ovisno o projektu, teoretski traje od
              godinu do nekoliko godina (najčešće četiri). Često se spominje MVP
              (minimum viable product), ali do produkcije postoji ih nekoliko.
              Možda jedan uzme samo mjesec-dva posla, ali u vrijeme uloženo u
              razvoj računaju se i svi oni pokušaji. Do ove je točke propalo
              više od 80% startupova.
              <br />
              CityX 2022. godinu završava izlazom iz ove faze, iako, s obzirom
              na kontinuirani razvoj, nikada neće u potpunosti izaći iz
              developmenta.
              <br />
              3. <b>Komercijalizacija</b> projekta koja zahtijeva nove
              organizacijske strukture, izuzetno jak marketing i skalabilne
              prodajne modele. Tu smo na 97% neuspjelih startupova.
              <br />
              4. <b>Izlaz</b>, eng. Exit, je termin koji je nerazdvojan od
              startupa. Nakon deset i više godina postojanja startup se tržišno
              dokazao, tim je pokazao sposobnost, odrađene su financijske serije
              A, B, C u milijunskim iznosima. Ovo je trenutak kada tvrtku želi
              akvizirati netko od tržišnih lidera koji dobro poznaje samu
              tržišnu nišu ili jednostavno IPO. Na godišnjoj razini (nekakav)
              exit ostvari nekoliko tisuća kompanija što je u postotku zanemariv
              broj u odnosu na broj pokrenutih startupova. Ipak, prosječan iznos
              exita je oko $800M. Reklo bi se- tko preživi, pričat će.
              <br />
              <br />
              <br />
              CityX je tvrtka koja njeguje sve najbolje što startup donosi. Kroz
              niz proizvoda naši planovi uključuju brzo širenje, dobro
              organiziranu internu strukturu, vrlo kvalitetnu organizaciju i
              protok informacija. Za cilj smo postavili širenje s dva projekta
              godišnje te kontinuirano ulaganje u R&#38;D. U zadnji kvartal
              2022. godine ulazimo s projektom CityX App u finalnu fazu
              komercijalizacije. CityX Tour&#38;Pass ulazi u fazu
              eksperimentalnog rada, a Sportter u fazu funkcionalnog prototipa.
              Cilj ovog teksta je približiti viziju CityX-a, a ako poželite
              saznati više detalja, slobodno nas kontaktirajte.
            </p>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default Carees_SiteContent;
